/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WebhookDelivery } from './WebhookDelivery';
import {
    WebhookDeliveryFromJSON,
    WebhookDeliveryFromJSONTyped,
    WebhookDeliveryToJSON,
    WebhookDeliveryToJSONTyped,
} from './WebhookDelivery';

/**
 * A delivery together with what went over the wire and its attempt history.
 * @export
 * @interface WebhookDeliveryDetail
 */
export interface WebhookDeliveryDetail {
    /**
     * 
     * @type {WebhookDelivery}
     * @memberof WebhookDeliveryDetail
     */
    delivery: WebhookDelivery;
    /**
     * The exact JSON we sent.
     * @type {string}
     * @memberof WebhookDeliveryDetail
     */
    requestBody: string;
    /**
     * What the endpoint answered, truncated to 2000 characters. Absent when nothing came back.
     * @type {string}
     * @memberof WebhookDeliveryDetail
     */
    responseBody?: string;
    /**
     * The original delivery and every redelivery of it, oldest first. The delivery itself is one of them.
     * @type {Array<WebhookDelivery>}
     * @memberof WebhookDeliveryDetail
     */
    attempts: Array<WebhookDelivery>;
    /**
     * 
     * @type {number}
     * @memberof WebhookDeliveryDetail
     */
    maxCustomerRetries: number;
}

/**
 * Check if a given object implements the WebhookDeliveryDetail interface.
 */
export function instanceOfWebhookDeliveryDetail(value: object): value is WebhookDeliveryDetail {
    if (!('delivery' in value) || value['delivery'] === undefined) return false;
    if (!('requestBody' in value) || value['requestBody'] === undefined) return false;
    if (!('attempts' in value) || value['attempts'] === undefined) return false;
    if (!('maxCustomerRetries' in value) || value['maxCustomerRetries'] === undefined) return false;
    return true;
}

export function WebhookDeliveryDetailFromJSON(json: any): WebhookDeliveryDetail {
    return WebhookDeliveryDetailFromJSONTyped(json, false);
}

export function WebhookDeliveryDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebhookDeliveryDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'delivery': WebhookDeliveryFromJSON(json['delivery']),
        'requestBody': json['requestBody'],
        'responseBody': json['responseBody'] == null ? undefined : json['responseBody'],
        'attempts': ((json['attempts'] as Array<any>).map(WebhookDeliveryFromJSON)),
        'maxCustomerRetries': json['maxCustomerRetries'],
    };
}

  export function WebhookDeliveryDetailToJSON(json: any): WebhookDeliveryDetail {
      return WebhookDeliveryDetailToJSONTyped(json, false);
  }

  export function WebhookDeliveryDetailToJSONTyped(value?: WebhookDeliveryDetail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'delivery': WebhookDeliveryToJSON(value['delivery']),
        'requestBody': value['requestBody'],
        'responseBody': value['responseBody'],
        'attempts': ((value['attempts'] as Array<any>).map(WebhookDeliveryToJSON)),
        'maxCustomerRetries': value['maxCustomerRetries'],
    };
}

